import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g fill="none" fillRule="evenodd" transform="translate(7 8)">
      <rect
        className="stroke-change"
        width="31"
        height="22"
        x="1.5"
        y="6.5"
        stroke="#9F9F9F"
        strokeWidth="3"
        rx="8"
      />
      <rect className="fill-change" width="7" height="3" x="6" y="13" fill="#9F9F9F" rx="1.5" />
      <rect className="fill-change" width="7" height="3" x="6" y="19" fill="#9F9F9F" rx="1.5" />
      <circle
        className="stroke-change"
        cx="22.5"
        cy="17.5"
        r="5"
        stroke="#9F9F9F"
        strokeWidth="3"
      />
      <path
        className="stroke-change"
        stroke="#9F9F9F"
        strokeLinecap="round"
        strokeWidth="3"
        d="M9 6.5L25 0"
      />
    </g>
  </svg>
);
